import { render } from "./FileSettingsModal.vue?vue&type=template&id=821de6de&scoped=true"
import script from "./FileSettingsModal.vue?vue&type=script&lang=js"
export * from "./FileSettingsModal.vue?vue&type=script&lang=js"

import "./FileSettingsModal.vue?vue&type=style&index=0&id=821de6de&scoped=true&lang=less"
import "./FileSettingsModal.vue?vue&type=style&index=1&id=821de6de&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821de6de"]])

export default __exports__